<template>
  <header class="mobile-detail-header">
    <button
      type="button"
      class="mobile-top-bar__icon-btn"
      :aria-label="backLabel"
      @click="goBack"
    >
      <IconBack />
    </button>
    <h1 class="mobile-detail-header__title">{{ title }}</h1>
    <button
      v-if="showActions"
      type="button"
      class="mobile-top-bar__icon-btn"
      aria-label="More actions"
      @click="$emit('open-actions')"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <circle cx="12" cy="5" r="1.8" />
        <circle cx="12" cy="12" r="1.8" />
        <circle cx="12" cy="19" r="1.8" />
      </svg>
    </button>
  </header>
</template>

<script>
import { useWorkSpaceStore } from "@/stores/workspace-store";
import { mapStores } from "pinia";
import { libraryRoute } from "@/utils/navigation";
import IconBack from "./icons/IconBack.vue";

export default {
  name: "MobileDetailHeader",
  components: { IconBack },
  props: {
    title: {
      type: String,
      default: "",
    },
    backLabel: {
      type: String,
      default: "Back to library",
    },
    // Explicit "up" target; defaults to the current workspace's Library
    // (see libraryRoute for why it's hierarchical, not history.back()).
    backTo: {
      type: [String, Object],
      default: null,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["open-actions"],
  computed: {
    ...mapStores(useWorkSpaceStore),
  },
  methods: {
    goBack() {
      this.$router.push(
        this.backTo || libraryRoute(this.$route, this.workspaceStore),
      );
    },
  },
};
</script>
